import { mapGetters, mapActions } from 'vuex'

const flexiquoteModuleName = 'flexiquotemodule'

export default {
  data() {
    return {
      savingStatus: null,
      showSavingStatus: false,
      toastNotificationEnabled: false
    }
  },
  computed: {
    ...mapGetters(flexiquoteModuleName, {
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      snapshots: 'snapshots',
      hasError: 'hasError',
      saving: 'saving',
      returnRoute: 'returnRoute'
    }),
    ...mapGetters(['debounceDelay'])
  },
  watch: {
    hasError(val) {
      if (val) {
        this.$notification.error('', 'Save Failed')
      }
    },
    saving(val) {
      this.showSavingStatus = true
      this.savingStatus = val ? 'Saving ...' : (!this.hasError ? 'Saved' : '')
      if (!val) {
        setTimeout(() => {
          this.showSavingStatus = false
        }, 2000)
      }
    }
  },
  methods: {
    ...mapActions(flexiquoteModuleName, [
      'getStoreItem',
      'addStoreItem',
      'clearSnapshots',
      'saveSnapshot',
      'saveInitialSnapshots',
      'setReturnRoute'
    ]),

    openToastNotification() {
      if (!this.hasError) {
        this.$notification.success('', 'Information has been successfully saved')
      }
    }
  }
}

